/**
 * Created by razial on 27.05.2025.
 */

const ExpHelper = {
    initialized: true,

    main: undefined,

    Initialize: function () {
        this.initialized = true;

        this.main = new Exp();

        cleverapps.exp = this.main;
    },

    Switch: function (locationId) {
        if (!this.initialized) {
            return;
        }

        if (cleverapps.exp !== this.main) {
            cleverapps.exp.destructor();
        }

        const locationMeta = cleverapps.meta.getLocationMeta(locationId);
        const locationConfig = locationMeta.locationConfig;

        if (locationConfig.withOwnGameLevel) {
            cleverapps.exp = new Exp(locationConfig);
            cleverapps.exp.load();
        } else {
            cleverapps.exp = this.main;
        }
    },

    GetMainInstance: function () {
        return this.main;
    }
};